<template>
  <div class="v_quick_rep_list g-flex-align-start">
    <div class="v-quick-rep-left g-flex-column">
      <!-- 左侧 -->
      <div class="v-quick-rep-left-head g-flex-align-start g-flex-column">
        <ul class="v-quick-rep-ope g-flex-align-center">
          <h3>快捷回复列表管理</h3>
          <el-upload class="upload-button" action="" :http-request="uploadFile" :show-file-list="false" :accept="uploadAccept" v-if="auth.importQuick">
            <li class="g-flex-align-center">
              <i class="el-icon-upload2"></i>
              <span>导入数据</span>
            </li>
          </el-upload>
          <li class="g-flex-align-center" @click="downFileClick" v-if="auth.exportQuick">
            <i class="el-icon-download"></i>
            <span>导出数据</span>
          </li>
          <!-- <li class="g-flex-align-center">
            <i class="el-icon-delete-solid"></i>
            <span>清空数据</span>
          </li> -->
        </ul>
        <p>预先设置一些常见问题的回复用语，帮助客服人员提高服务效率</p>
        <el-button  icon="el-icon-folder-add" type="primary" @click="setZhu" v-if="auth.addZhu">添加分组</el-button>
      </div>

      <!-- 左边树形 -->
      <div class="v-quick-rep-left-content g-self-scrollbar">
        <el-tree class="v-custom-tree" :data="treeData" node-key="id" :props="menu_props" :default-expand-all="false" :check-on-click-node="true" :expand-on-click-node="false">
          <div class="v-custom-tree-node g-flex-align-center" slot-scope="{ node, data }">
            <!-- 主题 -->
            <span class="v-tree-label-name">{{ node.label }}</span>
            <!-- 消息 -->
            <div v-if="data.msg" class="v-tree-item-msg" :title="data.msg">{{data.msg}}</div>
            <!-- 每一项按钮 -->
            <div class="g-flex-align-center g-flex-justify-end s-tree-right-box">
              
              <div class="g-flex-align-center s-tree-right-btn-item" @click="upItemClick(data)" v-if="auth.sortQuick">
                <i class="iconfont icon-shangyi" title="上移"></i>
              </div>

               <div class="g-flex-align-center s-tree-right-btn-item" @click="downItemClick(data)" v-if="auth.sortQuick">
                <i class="iconfont icon-xiayi" title="下移"></i>
              </div>
              <!-- 分组 -->
              <div class="g-flex-align-center s-tree-right-btn-item" v-show="data.parent_id === 0 && auth.changeHuifu" @click="setHuiFu(data)">
                <i class="el-icon-plus"></i>
                <el-button type="text" size="mini">添加回复</el-button>
              </div>
              <div class="g-flex-align-center s-tree-right-btn-item" v-show="data.parent_id === 0 && auth.addZhu" @click="setZhu(data)">
                <i class="el-icon-edit"></i>
                <el-button type="text" size="mini">重命名</el-button>
              </div>
              <div class="g-flex-align-center s-tree-right-btn-item" v-show="data.parent_id === 0 && auth.deleteQuick" @click="removeZhu(data)">
                <i class="el-icon-delete"></i>
                <el-button type="text" size="mini">删除</el-button>
              </div>

              <!-- 消息 -->
               <div class="g-flex-align-center s-tree-right-btn-item" v-show="data.parent_id !== 0 && auth.changeHuifu" @click="setHuiFu(data)">
                <i class="el-icon-delete"></i>
                <el-button type="text" size="mini">修改</el-button>
              </div>
              <div class="g-flex-align-center s-tree-right-btn-item" v-show="data.parent_id !== 0 && auth.deleteQuick" @click="removeZhu(data)">
                <i class="el-icon-delete"></i>
                <el-button type="text" size="mini">删除</el-button>
              </div>
            </div>
          </div>
        </el-tree>
      </div>
    </div>

    <!-- 右侧 -->
    <div class="v-quick-rep-right">
      <h6>导入快捷回复</h6>
      <p>导入快捷回复支持美洽和商务通，格式为 Excel</p>
      <div class="v-quick-rep-right-btn">
        <span>下载</span>
        <label @click="templateDownload">《快捷回复导入模板.xslx》</label>
      </div>
    </div>

    <!-- 添加分组编辑弹窗 -->
    <el-dialog :title="formData.id ? '修改分组': '添加分组'" :visible.sync="form" width="40%">
      <el-form :model="formData" label-width="100px">
         <el-form-item label="分组名:">
            <el-input type="textarea" v-model="formData.title" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="form = false">取 消</el-button>
        <el-button type="primary" @click="sureZhu">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加编辑回复弹窗 -->
    <el-dialog :title="formDataHuifu.id ? '修改回复': '添加回复'" :visible.sync="form2" width="40%">
      <el-form :model="formDataHuifu" label-width="100px">
         <el-form-item label="分组名:">
            <el-input v-model="formDataHuifu.groupName" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="主题:">
            <el-input v-model="formDataHuifu.title" autocomplete="off"></el-input>
          </el-form-item>
           <el-form-item label="内容:">
            <el-input type="textarea" v-model="formDataHuifu.msg" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="form2 = false">取 消</el-button>
        <el-button type="primary" @click="sureHuifu">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiGetReplyList, apiAddReply, apiDelReply, apiReplyFileImport, apiReplyFileExport, apiReplySort } from '@/utils/api.js'
export default {
  data() {
    return {
      uploadAccept: ".xls, .csv, xlsx",

      templateDownUrl: '/upload/demo.xlsx', //模板下载地址

      auth: {
          addZhu: this.$global.ApiList.includes(64),
          changeHuifu: this.$global.ApiList.includes(64),
          deleteQuick: this.$global.ApiList.includes(65),
          sortQuick:  this.$global.ApiList.includes(66), 
          importQuick: this.$global.ApiList.includes(67),
          exportQuick: this.$global.ApiList.includes(68),
      },

      form: false,

      form2: false,
      formData: {
        parent_id: 0,
        title: ''
      },
      
      formDataHuifu: {
        id: null,
        parent_id: null,
        groupName: '',
        title: '',
        msg: ''
      },

      treeData: [],

      menu_props: {
        children: 'children',
        label: 'title'
      }
    };
  },
  created() {
    this.getList()
  },
  methods: {
    // 下载模板
    templateDownload() {
      if(!this.templateDownUrl) return
      let a = document.createElement('a')
      a.setAttribute('href', this.templateDownUrl)
      a.setAttribute('download', "")
      a.click()
    },

    // 导入
    async uploadFile(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      const loading = this.$loading()
      const { success, data } = await apiReplyFileImport(formData)
      loading.close()
      if(!success) return
      this.$message.success(data.msg)
      this.getList()
    },

    // 导出
    async downFileClick() {
      let loading = this.$loading()
      const { success, data } = await apiReplyFileExport()
      loading.close()
      if(!success) return
      // console.log(data)
      let a = document.createElement('a')
      a.setAttribute('href', data.filePath)
      a.setAttribute('download', "")
      a.click()
    },

    // 上移动
    upItemClick(data) {
      // console.log('当前项', data)
      if(data.parent_id) {
       let findSonList = this.treeData.find(item =>{
          return item.id === data.parent_id
        }).children
        let findSon = findSonList.find(son => {
          return son.id === data.id
        })
        let index = findSonList.indexOf(findSon)
        if(index === 0) return this.$message.error('不能再向上了哦')
        this.apiReplySortHandel(data.id, findSonList[index - 1].id)
        // console.log('上一项', findSonList[index - 1])
      }else {
        let findItem = this.treeData.find(item => {
          return item.id === data.id
        })
        let index = this.treeData.indexOf(findItem)
        if(index === 0) return this.$message.error('不能再向上了哦')
         this.apiReplySortHandel(data.id, this.treeData[index - 1].id)
        // console.log('上一项', this.treeData[index - 1])
      }
    },

    // 下移动
    downItemClick(data) {
      // console.log('当前项', data)
      if(data.parent_id) {
       let findSonList = this.treeData.find(item =>{
          return item.id === data.parent_id
        }).children
        let findSon = findSonList.find(son => {
          return son.id === data.id
        })
        let index = findSonList.indexOf(findSon)
        if(index === findSonList.length - 1) return this.$message.error('不能再向下了哦')
        this.apiReplySortHandel(data.id, findSonList[index + 1].id)
        // console.log('下一项', findSonList[index + 1])
      }else {
        let findItem = this.treeData.find(item => {
          return item.id === data.id
        })
        let index = this.treeData.indexOf(findItem)
        if(index === this.treeData.length - 1) return this.$message.error('不能再向下了哦')
         this.apiReplySortHandel(data.id, this.treeData[index + 1].id)
        // console.log('下一项', this.treeData[index + 1])
      }
    },

    // 排序
    async apiReplySortHandel(id, jh_id) {
      let loading = this.$loading()
      const { success, data } = await apiReplySort({ id: id, jh_id: jh_id})
      loading.close()
      if(!success) return
      // console.log(data)
      this.$message.success(data.msg)
      this.getList()
    },

    // 获取列表
    async getList() {
      const { success, data } = await apiGetReplyList()
      if(!success) return
      this.treeData = this.dealTreeData(data.list, 0)
      // console.log('list', this.treeData)
    },

    // 处理数据
    dealTreeData(MenuArr, parent_id) {
      let reqList = []
      MenuArr.forEach(item => {
        if(item.parent_id == parent_id) {
          let children = this.dealTreeData(MenuArr, item.id)
          if(children.length > 0) item.children = children
          reqList.push(item)  
        }
      })
      return reqList
    },

    // 添加 重命名分组
    setZhu(data = { title: '', id: ''}) {
      this.formData.title = data.title
      this.formData.id = data.id
      this.form = true
    },

    // 确定 分组
    async sureZhu() {
      let loading = this.$loading()
      const { success, data } = await apiAddReply(this.formData)
      loading.close()
      if(!success) return
      this.$message.success(data.msg)
      this.getList()
      this.form = false
    },

    // 添加 编辑 回复
    setHuiFu(data) {
      if(!data.parent_id) { //如果是添加回复
        this.formDataHuifu.parent_id = data.id
        this.formDataHuifu.groupName = data.title
        this.formDataHuifu.id = ''
        this.formDataHuifu.title = ''
        this.formDataHuifu.msg = ''
      }else { //如果是修改回复
        this.formDataHuifu.id = data.id
        this.formDataHuifu.msg = data.msg
        this.formDataHuifu.parent_id = data.parent_id
        this.formDataHuifu.groupName = this.treeData.find(item => { return item.id === data.parent_id }).title
        this.formDataHuifu.title = data.title
      }
      this.form2 = true
    },

    // 确定 回复
    async sureHuifu() {
      let loading = this.$loading()
      const { success, data } = await apiAddReply(this.formDataHuifu)
      loading.close()
      if(!success) return
      this.$message.success(data.msg)
      this.getList()
      this.form2 = false
    },

    // 删除组 回复
    removeZhu({ id }) {
        this.$confirm('将永久删除当前选中节点, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let loading = this.$loading()
        const { success, data } = await apiDelReply({id: id})
        loading.close()
        if(!success) return
        this.$message.success(data.msg)
        this.getList()
      }).catch(() => {})
    }
  }
};
</script>

<style lang="scss">
.v_quick_rep_list {
  height: 100%;
  background: $chatContainerBg;
  padding-top: 20px;
  padding-left: 20px;
  // 左边
  .v-quick-rep-left {
    flex: 3;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 60px;
    // 头部
    .v-quick-rep-left-head {
      background: $white;
      padding: 20px 30px;
      .v-quick-rep-ope {
        h3 {
          font-size: $small-more-font-size;
          padding-right: 10px;
        }
        li {
          cursor: pointer;
          padding: 0 10px;
          color: $mainBlue;
          span {
            font-size: $most-font-size;
            padding-left: 6px;
          }
        }
      }
      p {
        color: #969faa;
        font-size: $small-font-size;
        padding-bottom: 14px;
      }
      .el-button {
        .el-icon-folder-add {
          font-size: 18px;
        }
        background: $mainBlue;
      }
    }
    // 树形
    .v-quick-rep-left-content {
      overflow-y: auto;
      flex: 1;
      margin-top: 20px;
      background: $white;
      .v-custom-tree {
        width: 100%;
        .el-tree-node__content {
          height: 40px;
        }
        .v-custom-tree-node {
          width: 100%;
          .v-tree-label-name {
            color: #000;
            font-size: $small-more-font-size;
          }

          .v-tree-item-msg {
            flex: 1;
            padding-left: 10px;
            font-size: $most-font-size;
            color: #858e99;
            width: 200px;
            @include textEllipsis();
          }
          .s-tree-right-box {
            flex: 1;
            padding-right: 30px;
            .s-tree-right-btn-item {
              padding: 0 6px;
              color: $mainBlue;
              .el-button {
                color: $mainBlue;
              }
              .icon-shangyi {
                font-size: 20px;
              }
              .icon-xiayi {
                font-size: 20px;
              }
            }
          }
        }
      }

    }
  }

  // 右边
  .v-quick-rep-right {
    flex: 2;
    padding-left: 30px;
    padding-top: 20px;
    color: #5a6978;
    font-size: $most-font-size;
    h6 {
      margin: 0;
      padding: 0;
      font-weight: normal;
      font-size: $small-more-font-size;
    }
    p {
      padding: 12px 0;
    }
    .v-quick-rep-right-btn {
      label {
        color: $mainBlue;
        padding-left: 4px;
        cursor: pointer;
      }
    }
  }
}
</style>
